import Chart from 'chart.js/auto';

const BatteryMetricsChart = {
  chart: null,

  mounted() {
    console.log('BatteryMetricsChart hook mounted');
    this.initChart();
  },

  updated() {
    console.log('BatteryMetricsChart hook updated');
    this.updateChart();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  initChart() {
    try {
      const ctx = this.el.getContext('2d');
      const chartData = JSON.parse(this.el.dataset.chartData);

      console.log('Battery Chart data:', chartData);

      const hasData = chartData.datasets && chartData.datasets.some(ds => 
        ds.data && ds.data.length > 0 && ds.data.some(v => v > 0)
      );

      this.chart = new Chart(ctx, {
        type: 'line',
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#666',
                font: { size: 12 },
                generateLabels: function(chart) {
                  return Chart.defaults.plugins.legend.labels.generateLabels(chart)
                    .filter(item => {
                      const dataset = chart.data.datasets[item.datasetIndex];
                      return dataset.data && dataset.data.some(v => v !== 0);
                    });
                }
              },
            },
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y.toFixed(0) + ' devices';
                  }
                  return label;
                }
              }
            },
          },
          scales: {
            x: {
              grid: {
                color: 'rgba(0, 0, 0, 0.05)',
                display: true,
              },
              ticks: { 
                color: '#666',
                maxRotation: 45,
                minRotation: 0
              },
            },
            y: {
              beginAtZero: true,
              grid: {
                color: 'rgba(0, 0, 0, 0.05)',
                borderDash: [5, 5],
              },
              ticks: { 
                color: '#666',
                callback: function(value) {
                  // Always show whole numbers for device counts
                  return Math.floor(value);
                }
              },
            },
          },
          elements: {
            point: {
              radius: chartData.labels && chartData.labels.length === 1 ? 6 : 4,
              hoverRadius: 8,
              backgroundColor: function(context) {
                return context.dataset.borderColor;
              }
            },
            line: {
              tension: 0.3,
              borderWidth: 2
            }
          }
        },
      });

      console.log('Battery chart initialized successfully');
    } catch (error) {
      console.error('Error initializing battery chart:', error);
    }
  },

  updateChart() {
    if (!this.chart) {
      this.initChart();
      return;
    }

    try {
      const newData = JSON.parse(this.el.dataset.chartData);
      
      this.chart.destroy();
      this.initChart();
      
    } catch (error) {
      console.error('Error updating battery chart:', error);
    }
  },
};

export default BatteryMetricsChart;